import React from "react";

interface IFooterProps {
  children: React.ReactNode; // Allow children to be passed
}

const Footer: React.FC<IFooterProps> = ({ children }) => {
  return (
    <footer className="h-[45px] w-full bg-gray-950 text-white flex items-center justify-center absolute bottom-0 left-0 right-0">
      {children}
    </footer>
  );
};

export default Footer;
